'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../_virtual/_tslib.js');

/**
 * Use fetch to perform an HTTP request
 * Add an optional timeout, that will abort the request if it has not returned before
 */
const fetchWithTimeout = (input, init) => {
    const abortController = new AbortController();
    const _a = init || {}, { timeout } = _a, rest = _tslib.__rest(_a, ["timeout"]);
    const params = Object.assign(Object.assign({}, rest), { signal: abortController.signal });
    if (timeout !== undefined) {
        setTimeout(() => abortController.abort(), timeout);
    }
    return fetch(input, params);
};

exports.fetchWithTimeout = fetchWithTimeout;
//# sourceMappingURL=fetch-with-timeout.js.map
